import { Container } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { noop } from '../../../lib/utils';
import BadgeType from '../../prop-types/badge';
import BadgeAd from '../BadgeAd';
import NoClickPropagation from '../NoClickPropagation';
import styles from './BadgeAds.module.css';

const cx = classnames.bind(styles);

export default function BadgeAds({
  badgeAdsById,
  badgeIds,
  error,
  fetchBadgeAds,
  isFetching,
}) {
  useEffect(() => {
    // If a badgeAdsById value is undefined, then it hasn't been fetched yet
    const badgeAdIdsNotFetched = badgeIds.filter(id => typeof badgeAdsById[id] === 'undefined');

    if (!isFetching && !error && badgeAdIdsNotFetched.length) {
      fetchBadgeAds(badgeAdIdsNotFetched);
    }
  }, [isFetching, badgeIds, badgeAdsById, fetchBadgeAds, error]);

  const badgeAds = Object.values(badgeAdsById);

  return badgeAds && (
    <Container>
      <div className={cx('badgeAds')}>
        {badgeAds.filter(Boolean).map(badge => (
          <NoClickPropagation key={badge.badgeId} className={cx('badgeAd')}>
            <BadgeAd {...badge} />
          </NoClickPropagation>
        ))}
      </div>
    </Container>
  );
}

BadgeAds.propTypes = {
  badgeAdsById: PropTypes.objectOf(PropTypes.shape({ [PropTypes.string]: BadgeType })),
  badgeIds: PropTypes.arrayOf(PropTypes.string),
  error: PropTypes.string,
  fetchBadgeAds: PropTypes.func,
  isFetching: PropTypes.bool,
};

BadgeAds.defaultProps = {
  badgeAdsById: {},
  badgeIds: [],
  error: undefined,
  fetchBadgeAds: noop,
  isFetching: false,
};
